import { useSmallScreen } from '@/hooks/useWindowDimension';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';
import classes from './TreeTypeLegend.module.css';

export const TreeTypeLegend = () => {
  const isSmallScreen = useSmallScreen();
  return (
    <div data-testid="tree-type-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle} id="treecover-type">
          Tree cover by tree type
        </div>
      )}
      <div className={`${legendClasses.legend} ${classes.layout}`}>
        <span>
          <span className={classes.deciduous} />
          Deciduous
        </span>
        <span>
          <span className={classes.evergreen} />
          Evergreen
        </span>
      </div>
    </div>
  );
};
